import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { TopRule } from "@/types/api";

interface TopRulesBarProps {
  rules: TopRule[];
}

export function TopRulesBar({ rules }: TopRulesBarProps) {
  const data = rules.slice(0, 8).map((r) => ({
    name: r.rule_name.length > 30 ? r.rule_name.slice(0, 27) + "..." : r.rule_name,
    count: r.alert_count,
  }));

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Top Triggered Rules</CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="py-8 text-center text-sm text-muted-foreground">
            No rule triggers in this period
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={data.length * 36 + 20}>
            <BarChart data={data} layout="vertical" margin={{ left: 0, right: 16 }}>
              <XAxis type="number" hide />
              <YAxis
                type="category"
                dataKey="name"
                width={180}
                tick={{ fontSize: 12, fill: "#a1a1aa" }}
              />
              <Tooltip />
              <Bar dataKey="count" fill="#6366f1" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
